module.exports = __webpack_public_path__ + "static/img/wariant3.dc52b93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wariant3.jpg
// module id = CDqv
// module chunks = 1